import { useDispatch, useSelector } from "react-redux";
import { setShift } from "redux/briefing/shiftSlice";

const ShiftSelector = () => {
  const dispatch = useDispatch();
  const shift = useSelector((state) => state.shift);

  const handleChange = (event) => {
    dispatch(setShift(event.target.value));
  };

  return (
    <div className="shift-selector-segmented" role="radiogroup" aria-label="Shift selector">
      <span className="shift-selector-title">Sticky Note</span>
      <label className="shift-pill first" data-active={shift === "first" ? "true" : "false"}>
        <input
          type="radio"
          name="shift"
          value="first"
          checked={shift === "first"}
          onChange={handleChange}
        />
        <span>1st</span>
      </label>
      <label className="shift-pill second" data-active={shift === "second" ? "true" : "false"}>
        <input
          type="radio"
          name="shift"
          value="second"
          checked={shift === "second"}
          onChange={handleChange}
        />
        <span>2nd</span>
      </label>
      <label className="shift-pill third" data-active={shift === "third" ? "true" : "false"}>
        <input
          type="radio"
          name="shift"
          value="third"
          checked={shift === "third"}
          onChange={handleChange}
        />
        <span>3rd</span>
      </label>
    </div>
  );
};

export default ShiftSelector;
